import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommonProvider } from '../common';
import { Response } from '../response';

@Injectable()
export class GoalRhProvider {
  constructor(public http: HttpClient,
    public commonProvider: CommonProvider) { }

  private _urlGoals: string = this.commonProvider.apiUrl + 'api/v1/goals';

  createGoalListWithGoals(title, goals): Observable<Response<any>> {
    return this.http.post<Response<any>>(this._urlGoals + '/createListWithGoals', { title, goals });
  }

  getGoalsList(): Observable<Response<any>> {
    return this.http.get<Response<any>>(this._urlGoals + '/getManagerGoalsList');
  }

  getAssignableUsers(): Observable<Response<any>> {
    return this.http.get<Response<any>>(this._urlGoals + '/listAssignableUsers');
  }

  assignListToUsers(list_id, users): Observable<Response<any>> {
    return this.http.post<Response<any>>(this._urlGoals + '/assignListToUsers', { list_id, users });
  }

  signList(signature, list_id): Observable<Response<any>> {
    return this.http.post<Response<any>>(this._urlGoals + '/signList', { list_id, signature });
  }

  getUserGoals(): Observable<Response<any>> {
    return this.http.get<Response<any>>(this._urlGoals + '/getUserGoals');
  }

  getGoalsOfUser(user_id): Observable<Response<any>> {
    return this.http.post<Response<any>>(this._urlGoals + '/listUserGoals', { user_id });
  }

  // PRHCI Goals Handlers
  savePRHCIGoals(process_goals): Observable<Response<any>> {
    return this.http.post<Response<any>>(this._urlGoals + '/savePRHCIGoals', { process_goals });
  }

  getPRHCIGoals(process): Observable<Response<any>> {
    return this.http.post<Response<any>>(this._urlGoals + '/getPRHCIGoals', { process });
  }

}




// WEBPACK FOOTER //
// ./src/providers/goals/goals.ts